// Shared flier-studio config: fonts available on both the browser (public/fonts) and the server (backend/fonts)
export const FONTS = [
  { key: "anton", label: "Bold Condensed", hint: "like your flier", css: "'Anton', 'Arial Narrow', sans-serif", weight: 400 },
  { key: "bebas", label: "Tall Caps", css: "'Bebas Neue', 'Arial Narrow', sans-serif", weight: 400 },
  { key: "oswald", label: "Oswald Bold", css: "'Oswald', sans-serif", weight: 700 },
  { key: "playfair", label: "Elegant Serif", css: "'Playfair Display', Georgia, serif", weight: 700 },
  { key: "cinzel", label: "Roman Capitals", css: "'Cinzel', Georgia, serif", weight: 700 },
  { key: "vibes", label: "Script", css: "'Great Vibes', cursive", weight: 400 },
  { key: "classic", label: "Classic Bold", css: "'Liberation Sans', Arial, sans-serif", weight: 700 },
];
export const fontOf = (key) => FONTS.find((f) => f.key === key) || FONTS[0];

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const ordinal = (n) => `${n}${11 <= n % 100 && n % 100 <= 13 ? "th" : { 1: "st", 2: "nd", 3: "rd" }[n % 10] || "th"}`;
// "MM-DD" -> "2nd September" (same format the server prints on fliers)
export const fmtBirthday = (b) => { if (!b || !b.includes("-")) return ""; const [m, d] = b.split("-").map(Number); return d && MONTHS[m - 1] ? `${ordinal(d)} ${MONTHS[m - 1]}` : ""; };

// Mirror of the server's text_lines(): uppercase + optional two-line stacking
export const textLines = (z, text) => {
  let t = z.upper === false ? text : text.toUpperCase();
  if (z.stack && t.trim().includes(" ")) { const [first, ...rest] = t.trim().split(" "); t = `${first}\n${rest.join(" ")}`; }
  return t;
};

const canvas = typeof document !== "undefined" ? document.createElement("canvas") : null;
// Largest font size (px) at which `text` fits the box, measured with the real web font
export const fitFontPx = (text, fontKey, boxW, boxH, maxPx) => {
  const f = fontOf(fontKey);
  const lines = text.split("\n");
  let size = Math.max(6, Math.min(maxPx, boxH / (lines.length + (lines.length - 1) * 0.08)));
  const ctx = canvas?.getContext("2d");
  if (!ctx) return size;
  while (size > 6) {
    ctx.font = `${f.weight} ${size}px ${f.css}`;
    const w = Math.max(...lines.map((l) => ctx.measureText(l).width));
    if (w <= boxW) break;
    size -= 1;
  }
  return size;
};
